import { PATHS } from '../config';

export const redirectToSignIn = () => {
  const redirectTo = window.location.pathname;
  window.location.href = `${window.location.origin}${PATHS.signIn}?redirectTo=${encodeURIComponent(redirectTo)}`;
};

